/* eslint-disable import/prefer-default-export */

const MINIMUM_TC_ICON_SIZE = 16;

export { MINIMUM_TC_ICON_SIZE };
